<template>
  <div
    class="style1-wap align-left"
    :class="{
      err: fieldObj.dirty && fieldObj.invalid
    }"
  >
    <a-checkbox
      @change="handleChange"
      :disabled="fieldObj.disabled"
      v-model="fieldObj.isSelected"
    >
      <span v-for="u in fieldObj.privacyPolicyTitle" :key="u">{{ u }}</span>
      <!--<a-->
        <!--class="u-policy-text"-->
        <!--@click.prevent="fieldPop = true"-->
        <!--&gt;{{ fieldObj.privacyPolicyUrlTitle }}</a-->
      <!--&gt;-->
      <a
        class="u-policy-text"
        :href="fieldObj.privacyPolicyUrl"

      >{{ fieldObj.privacyPolicyUrlTitle }}</a
      >
    </a-checkbox>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
    <transition name="top">
      <div class="pop-policy" v-if="fieldPop">
        <div class="pop-policy-header">
          <div class="pop-policy-title">
            <span v-for="u in fieldObj.privacyPolicyTitle" :key="u">{{ u }}</span>
          </div>
          <div class="pop-policy-close" @click="fieldPop = false">
            <div class="icontemp stemp-close"></div>
          </div>
        </div>
        <div class="iframe-wrapper">
          <iframe class="iframe-wrapper-con" :src="fieldObj.privacyPolicyUrl" frameborder="0"></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import policyMixin from "../../field/new-fields/policy";
export default {
  name: "sk-policy-wap",
  mixins: [policyMixin]
};
</script>
<style>
.align-left {
  text-align: left;
}
</style>
